import React, { useEffect , useState} from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, Image } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';

import { VscTrash } from 'react-icons/vsc';
import { MdPublish } from 'react-icons/md';

const Main = (props) => {
    return (
		<Card className="appCard add-card" style={props.style}>
			<Row>
				<Col xs={12}>
					<div className="hover-container" onClick={() => props.onClick(props.id)}>
						<Card.Title className="item-card-title">{props.label}</Card.Title>
						<p className="item-card-body">{props.description}</p>
						{/* <p className="item-card-status">{props.status.toUpperCase()}</p> */}
					</div>
				</Col>
			</Row>
			<Row>
				<Col className="d-flex" >
					{props.canDelete ? (
						<div className="delete">
							<button className="item-card-delete" onClick={props.onDelete}>
								<VscTrash size={22} data-tip="Delete Item" />
							</button>
						</div>
					) : null}
					{props.canPublish ? (
						<div className="delete ml-3">
							<button className="item-card-delete" onClick={props.onPublish}>
								<MdPublish size={22} data-tip="Publish Item" />
							</button>
						</div>
					) : null}
				</Col>
			</Row>
			<ReactTooltip />
		</Card>
	);
};

Main.propTypes = {
	label: PropTypes.string,
	description: PropTypes.string,
	tooltip: PropTypes.string,
	type: PropTypes.string,
	key: PropTypes.string,
	style: PropTypes.object,
	onClick: PropTypes.func,
	onDelete: PropTypes.func,
	onPublish: PropTypes.func,
	canDelete: PropTypes.bool,
	canPublish: PropTypes.bool
};

Main.defaultProps = {
	label: 'Create new',
	description: 'This is the description of the store item',
	tooltip: 'This is the description of the store item',
	type: 'Research',
	canDelete: true,
	canPublish: true,
	style: {},
	onClick: () => console.log('Add:OnClick: No Action Performed'),
	onDelete: () => console.log('Add:onDelete: No Action Performed'),
	onPublish: () => console.log('Add:onPublish: No Action Performed')
};

export default Main;
